import { SortType } from './types';

export const sortList: Array<SortType> = [
  { name: 'Best Selling', value: 'best-selling' },
  { name: 'Price (Low to High)', value: 'price-asc' },
  { name: 'Price (High to Low)', value: 'price-desc' },
  { name: 'Latest Release', value: 'latest-release' },
];
